import { AvField, AvForm } from "availity-reactstrap-validation"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

import Select from "react-select"
import {
  createClient,
  getBranches,
  getDistricts,
  getStates,
  updateClient,
} from "store/actions"
import useRole from "hooks/useRole"
import { CountryCode } from "constants/countryValues"

const ClientModal = ({ show, onCloseClick, updateData }) => {
  const dispatch = useDispatch()
  const { isSuperAdmin } = useRole()

  const { allDistricts, allState, branches, branchLoading } = useSelector(
    state => ({
      allState: state?.Client?.states?.States,
      allDistricts: state?.Client?.districts?.districts,
      branches: state.Branches.branches,
      branchLoading: state.Branches.loading,
    })
  )

  const [state, setState] = useState("")
  const [stateId, setStateId] = useState("")
  const [stateSearch, setStateSearch] = useState("")

  const [district, setDistrict] = useState("")
  const [districtId, setDistrictId] = useState("")
  const [districtSearch, setDistrictSearch] = useState("")
  const [branch, setBranch] = useState("Select Branch...")
  const [branchId, setBranchId] = useState("")
  const [branchSearch, setBranchSearch] = useState("")

  const defaultCountryCode = { label: "+91 (India)", value: "+91" }
  const [countryCode, setCountryCode] = useState(defaultCountryCode)
  const [whatsappCountryCode, setWhatsappCountryCode] = useState(defaultCountryCode)

  const countryCodeOptions = CountryCode.map(c => ({
    label: `${c.code} (${c.name})`,
    value: c.code,
  }))

  useEffect(() => {
    if (isSuperAdmin()) {
      dispatch(getBranches(1, 10, branchSearch, "", ""))
    }
  }, [dispatch, branchSearch])

  useEffect(() => {
    dispatch(getStates(stateSearch))
  }, [dispatch, stateSearch])

  useEffect(() => {
    setDistrictId(updateData?.address?.district?._id)
    setDistrict(updateData?.address?.district?.name)

    setState(updateData?.address?.state?.name)
    setStateId(updateData?.address?.state?._id)

    // Pre-populate country codes from existing data
    if (updateData?.countryCode || updateData?.phoneCountryCode) {
      const code = updateData.countryCode || updateData.phoneCountryCode
      const match = CountryCode.find(c => c.code === code)
      setCountryCode(
        match
          ? { label: `${match.code} (${match.name})`, value: match.code }
          : defaultCountryCode
      )
    } else {
      setCountryCode(defaultCountryCode)
    }
    if (updateData?.whatsappCountryCode) {
      const match = CountryCode.find(c => c.code === updateData.whatsappCountryCode)
      setWhatsappCountryCode(
        match
          ? { label: `${match.code} (${match.name})`, value: match.code }
          : defaultCountryCode
      )
    } else {
      setWhatsappCountryCode(defaultCountryCode)
    }
  }, [updateData])

  const stateOptions = [
    {
      options: allState?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredStates = textEntered => {
    setStateSearch(textEntered)
  }

  function handleFinalValuesStates(event) {
    setState(event.label)
    setStateId(event.value)
  }

  useEffect(() => {
    dispatch(getDistricts(stateId, districtSearch))
  }, [dispatch, stateId, districtSearch])

  const districtOptions = [
    {
      options: allDistricts?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredDistrict = textEntered => {
    setDistrictSearch(textEntered)
  }

  function handleFinalValuesDistrict(event) {
    setDistrict(event.label)
    setDistrictId(event.value)
  }

  const handleValidSubmit = (e, v) => {
    const clientUpdate = {
      name: v?.name,
      phone: v?.phone,
      whatsappNumber: v?.whatsappNumber,
      email: v?.email,
      branch: branchId,
      countryCode: countryCode?.value || "+91",
      whatsappCountryCode: whatsappCountryCode?.value || "+91",
      address: {
        addressLine1: v?.addressLine1,
        addressLine2: v?.addressLine2,
        district: districtId,
        state: stateId,
        pincode: v?.pincode,
      },
    }
    if (updateData?._id) {
      dispatch(updateClient(clientUpdate, updateData?._id, ""))
      onCloseClick()
    } else {
      const clientCreate = {
        ...v,
        branch: branchId,
        countryCode: countryCode?.value || "+91",
        whatsappCountryCode: whatsappCountryCode?.value || "+91",
      }
      dispatch(createClient(clientCreate, onCloseClick))
      onCloseClick()
    }
  }
  useEffect(() => {
    if (updateData) {
      setBranch(updateData?.branch?.branch_name)
      setBranchId(updateData?.branch?._id)
    }
  }, [updateData, updateData])
  const branchOptions = [
    {
      options: branches?.branches?.map((result, index) => ({
        key: index,
        label: result?.branch_name,
        value: result._id,
      })),
    },
  ]
  const handleEnteredBranch = textEntered => {
    setBranchSearch(textEntered)
  }
  function handleFinalValuesBranch(event) {
    setBranch(event.label)
    setBranchId(event.value)
  }
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id ? "Edit Client" : "Add New Client"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              <Col className="col-12 mb-2">
                <label>
                  Name <span className="text-danger"> *</span>
                </label>
                <AvField
                  name="name"
                  type="text"
                  placeholder="Enter Name "
                  value={updateData?.name}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "name is required",
                    },
                  }}
                />
              </Col>
            </>
          </Row>
          {/* Phone — full width row */}
          <Row className="mb-2">
            <Col className="col-12 mt-1">
              <label>
                Phone <span className="text-danger">*</span>
              </label>
              <div className="input-group" style={{ flexWrap: "nowrap" }}>
                <div style={{ width: "160px", flexShrink: 0 }}>
                  <Select
                    value={countryCode}
                    onChange={setCountryCode}
                    options={countryCodeOptions}
                    classNamePrefix="select2-selection"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      control: base => ({
                        ...base,
                        minHeight: "38px",
                        borderRadius: "4px 0 0 4px",
                        borderRight: "none",
                      }),
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <AvField
                    name="phone"
                    type="number"
                    placeholder="Enter phone number"
                    value={updateData?.phone}
                    style={{ borderRadius: "0 4px 4px 0", height: "38px" }}
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Phone number is required",
                      },
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>

          {/* WhatsApp — full width row */}
          <Row className="mb-2">
            <Col className="col-12 mt-1">
              <label>WhatsApp Number</label>
              <div className="input-group" style={{ flexWrap: "nowrap" }}>
                <div style={{ width: "160px", flexShrink: 0 }}>
                  <Select
                    value={whatsappCountryCode}
                    onChange={setWhatsappCountryCode}
                    options={countryCodeOptions}
                    classNamePrefix="select2-selection"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      control: base => ({
                        ...base,
                        minHeight: "38px",
                        borderRadius: "4px 0 0 4px",
                        borderRight: "none",
                      }),
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <AvField
                    name="whatsappNumber"
                    type="number"
                    placeholder="Enter WhatsApp number"
                    value={updateData?.whatsappNumber}
                    style={{ borderRadius: "0 4px 4px 0", height: "38px" }}
                    validate={{
                      required: {
                        value: false,
                        errorMessage: "WhatsApp number is required",
                      },
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>

          {/* Branch — superadmin only */}
          {isSuperAdmin() && (
            <Row className="mb-2">
              <Col className="col-12">
                <label>
                  Branch <span className="text-danger">*</span>
                </label>
                <Select
                  onInputChange={handleEnteredBranch}
                  value={branch}
                  placeholder={branch}
                  onChange={handleFinalValuesBranch}
                  options={branchOptions}
                  classNamePrefix="select2-selection"
                  isLoading={branchLoading}
                />
              </Col>
            </Row>
          )}

          {updateData?._id ? (
            <>
              <Row>
                <Col className="col-12 py-3">
                  <AvField
                    name="email"
                    label="Email"
                    type="mail"
                    placeholder="Enter Email"
                    value={updateData?.email ?? ""}
                  />
                </Col>
              </Row>
              <Col className="mb-3">
                <AvField
                  label="Address Line 1"
                  name="addressLine1"
                  type="textarea"
                  placeholder="Enter your address"
                  value={updateData?.address?.addressLine1 ?? ""}
                />
              </Col>
              <Col className="">
                <AvField
                  name="addressLine2"
                  label="Address Line 2"
                  type="textarea"
                  placeholder="Enter your address"
                  value={updateData?.address?.addressLine2 ?? ""}
                />
              </Col>
              <Row className="py-2">
                <Col className="col-6">
                  <label>State</label>
                  <Select
                    onInputChange={handleEnteredStates}
                    value={state}
                    placeholder={state}
                    onChange={handleFinalValuesStates}
                    options={stateOptions}
                    classNamePrefix="select2-selection"
                    isLoading={""}
                  />
                </Col>
                <Col className="col-6">
                  <label>District</label>
                  <Select
                    onInputChange={handleEnteredDistrict}
                    value={district}
                    placeholder={district}
                    onChange={handleFinalValuesDistrict}
                    options={districtOptions}
                    classNamePrefix="select2-selection"
                    isLoading={""}
                  />
                </Col>
              </Row>
              <Row className="py-2">
                <Col className="col-12">
                  <AvField
                    name="pincode"
                    type="number"
                    label="Pincode"
                    placeholder=" Pincode"
                    value={updateData?.address?.pincode ?? ""}
                  />
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

ClientModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}

export default ClientModal
